<template>
  <div class="skeleton-loading">
    <span class="w-40"></span>
    <span class="w-50"></span>
    <span class="w-30"></span>
    <span class="w-40"></span>
    <span class="w-50"></span>
  </div>
</template>

<style lang="scss">
.skeleton-loading {
  display: block;
  > * {
    display: block;
    min-height: 10px;
    background: #ddd;
    margin: 15px 0;
    border-radius: 50px;
  }
}
</style>
